<template>
    <div class="project-details-sidebar">
      <div v-if="!detailsLoader" class="project-details-wrap">
          <div class="details-level1">
            <div class="go-back" @click="closeDetails">
              <span></span>
            </div>
            <div class="nway">
              <h4>Traject: <span>{{trajectory.beheer_object}}</span></h4>
            </div>
          </div>
          <div class="details-level2">
            <div class="details-level2__direction" v-if="trajectories.length">
              <label>Rijrichting</label>
              <button @click="onDriveDirectionChange(DriveDirections.Left)" :disabled="driveDirection === DriveDirections.Left">
                Heen
              </button>
              <button @click="onDriveDirectionChange(DriveDirections.Right)" :disabled="driveDirection === DriveDirections.Right">
                Terug
              </button>
            </div>
            <ToggleContent :title="`Traject informatie (${filters.year - 1})`">
              <PathwayInfo></PathwayInfo>
            </ToggleContent>
            <ToggleContent title="Traject voorspellen">
              <PathwayPredict></PathwayPredict>
            </ToggleContent>
          </div>
        </div>
      <div v-else>
        <loader></loader>
      </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

import Loader from '@/components/Loader'
import ToggleContent from '@/components/ToggleContent'
import Crow146 from '@/components/trajectory/Crow-146'
import PathwayPredict from '@/components/trajectory/PathwayPredict'
import PathwayInfo from '@/components/trajectory/PathwayInfo'
import DriveDirections from '../../src/driveDirection'

export default {
  data () {
    return {
      DriveDirections: DriveDirections,
      detailsLoader: false
    }
  },
  watch: {
    filters: function () {
      this.$store.dispatch('setTrajectory', null)
    }
  },
  methods: {
    closeDetails () {
      this.$store.dispatch('setTrajectory', null)
    },
    onDriveDirectionChange (direction) {
      this.$store.dispatch('setDriveDirection', direction)
    }
  },
  computed: {
    ...mapState(['driveDirection', 'trajectory', 'trajectories']),
    ...mapState('projects', ['filters'])
  },
  components: {
    Loader,
    Crow146,
    PathwayInfo,
    ToggleContent,
    PathwayPredict
  }
}
</script>
<style lang="sass" scoped>
@import '../sass/variables'

.crow-146
  padding: 2em 0 1em

// Table layout
.rTable
   display: table
   width: 100%
.rTableRow
   display: table-row
.rTableHeading
   display: table-header-group
   background-color: #ddd
.rTableCell, .rTableHead
   display: table-cell
   padding: 3px 10px
   border: 1px solid #999999
.rTableHeading
   display: table-header-group
   background-color: #ddd
   font-weight: bold
.rTableFoot
   display: table-footer-group
   font-weight: bold
   background-color: #ddd
.rTableBody
   display: table-row-group

.project-details-wrap
   box-shadow: 0 2px 15px 0 rgba(0,0,0,0.2)
   background-color: $white
   height: 100%
%arrow-icons
  content: ''
  display: inline-block
  background-image: url('../assets/images/little-dropdown.svg')
  background-position: center center
  background-repeat: no-repeat !important
  width: 0.95em
  height: 0.75em
  background-size: 100%
  margin-left: 0.93em
.project-details-sidebar
   position: absolute
   right: 0
   top: 0
   box-shadow: 0 2px 15px 0 rgba(0,0,0,0.2)
   background-color: $white
   z-index: 2000
   width: 100%
   max-width: 46em
   height: 100%
   overflow: hidden
   .details-level1
     display: flex
     height: 4.06em
     box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2)

     div.go-back
      flex: 0.095
      background: linear-gradient(225deg, #033B9A 0%, #002563 100%)
      transition: 0.4s
      &:hover
        background: linear-gradient(225deg,#E7314C 0%, #B01C32 100%)
      span
        background-image: url('../assets/icons/white-arrow.svg')
        height: 100%
        width: 100%
        display: block
        margin: 0
        background-position: center center
        background-repeat: no-repeat
        cursor: pointer
     div.nway
      display: flex
      align-items: center
      flex: 1
      h4
        margin: 0 0.5em 0 1em
        font-size: 1.125em
        line-height: normal
        span
          text-transform: uppercase

   .details-level2
     display: flex
     padding: 1.5em 5em 0
     flex-direction: column
     overflow-y: auto
     height: calc( 100% - 123px)
     .block
        padding-right: 1.7em
        flex: 1
        li
          display: flex
          flex-wrap: wrap
          border-bottom: 1px solid $light-grey
          margin-bottom: 0.27em
          font-size: 0.88em
          &:last-child
            border-bottom: 0
          label
            flex: 1
            color: #BCBCBC
            line-height: 1.8em
          span
            flex: 1.5

     .column-direction
        li
          flex-direction: column
          label,span
            border-bottom: 1px solid $light-grey
          span
            border-bottom: 0

.details-level2
  &__direction
    display: flex
    align-items: center
    margin: 1.5625em 0 1.875em
    label
      margin-right: 1.875em
  button
    color: $blue
    border: none
    outline: none
    font-size: 0.875em
    line-height: 1.25em
    padding: 0.875em 2.375em
    font-weight: 700
    &:not(:disabled)
      background-color: #FFFFFF
      box-shadow: 0 2px 4px 0 rgba(0,0,102,0.3)
    &:disabled
      background-color: $grey
</style>



// WEBPACK FOOTER //
// src/pages/Trajectory.vue